import MotivoCancelamentoModel from "../models/motivoCancelamentoModel";

import { IService } from "./base/iService";

export default class MotivoCancelamentoService extends IService<MotivoCancelamentoModel> {
    constructor() {
        super("MotivoCancelamento");
    }
}